module.exports = __webpack_public_path__ + "img/31.5.COD.2a636319.png";